import { createAction } from 'redux-actions'
import { actionCreators as api } from 'reduxBits/api/actions'
import log from 'sentry/log'

const prefix = 'PrivateProfile: '

export const SET_USER_DATA = `${prefix} Set error object`
export const setUserData = createAction(SET_USER_DATA)

export const fetchUserData = () => async (dispatch) => {
  try {
    const response = await dispatch(api.fetch('profile-be/v1/profiles'))
    dispatch(setUserData(response))
  } catch (e) {
    log.error(`Private profile fetch error: ${e}`)
  }
}
